import SunsetPage from './SunsetPage.container';

export default SunsetPage;
